// chat feature
export default {
  'Camera not found, please check your browser settings.': '未找到摄像头，请检查浏览器权限',
  Send: '发送',
  'Please type something...': '请输入内容...',
  Picture: '图片',
  File: '文件',
  Download: '点击下载',
  'You have a new message': '有新消息',
  'Click to check': '点击查看',
  'Online Service': '在线客服',
  'Customer service': '客服',
  'Chat features will not work if you keep using IE, please try other brwosers': '音视频聊天不可用，建议使用谷歌或其他浏览器',
  'You are going to invate': '您将要发起',
  'with someones invitation': '与{0}的邀约',
  'According to the platform analyze': '根据平台统计，沟通后发起的邀约，成功率可提升80%',
  'Chat now': '现在就沟通：',
  'Send message': '发消息',
  'waiting for someones response': '正在等待{0}接受申请',
  'chat with someone': '正在与{0}通话',
  'request': '请求',
  'video': '视频',
  'audio': '音频',
  'calling': '通话',
  'callee is not online!': '对方不在线。',
  'No network at the moment': '已断开，正在尝试自动重连...',
  'Connecting': '连接中...',
  'Request video call': '请求视频通话',
  'Request audio call': '请求音频通话',
  'Chat History': '聊天记录',
  'Someone chat history': '与{0}的聊天记录',
  'Load more': '加载更多'
}
